var React = require('react');

function CH (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#d52b1e","d":"M0 0h640v480H0z","key":0}),React.createElement("g",{"fill":"#fff","key":1},[React.createElement("path",{"d":"M170 195h300v90H170z","key":0}),React.createElement("path",{"d":"M275 90h90v300h-90z","key":1})])]));
}

CH.defaultProps = {"id":"flag-icon-css-ch","width":"640","height":"480"};

module.exports = CH;

CH.default = CH;
